<div class="container" *ngIf="packages">
    <div class="m-3">
        <div class="d-flex align-items-center">
            <div class="general-icons-sm me-2">
                <img src="../../assets/images/packages.svg">
            </div>
            <h1 class="display-6 m-0">{{ 'Subscription.Packages' | translate:locale.language }}</h1>
        </div>
        <hr>
        <div class="row">

            <div class="col-xl-4 col-md-12 mb-3">
                <div class="card d-flex justify-content-between h-100">
                        <div class="card-header d-flex justify-content-between bg-basic p-0 ">
                            <div class="p-4 text-uppercase">
                                <h1 class="fw-bold border-bottom border-dark border-2">{{ 'Subscription.PackageBasic' | translate:locale.language }}</h1>
                                <span>{{ 'Core.Registration' | translate:locale.language }}</span>
                            </div>
                          <div class="position-relative">
                            <div class="stars">
                                <i class="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-4 h-100">
                            <h3 class="price mb-5">{{ 'Subscription.Free' | translate:locale.language }}</h3>
                            <ul class="list-unstyled price-list mt-4">
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureSDMT' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureIMCI' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureTrial' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureKB' | translate:locale.language }}</span>
                            </li>
                        </ul>
                        </div>
                        <!-- <div class="p-4">
                            <a class="btn btn-warning btn-lg w-100" href="#">Regisztráció</a>
                        </div> -->
                    </div>
                        
                               
                               
                </div>
                   
                <div class="col-xl-4 col-md-12 mb-3">
                    <div class="card d-flex justify-content-between h-100">
                        <div class="card-header d-flex justify-content-between bg-gold p-0 ">
                            <div class="p-4 text-uppercase">
                                <h1 class="fw-bold border-bottom border-dark border-2">{{ 'Subscription.PackageGold' | translate:locale.language }}</h1>
                                <span>{{ 'Subscription.subscription' | translate:locale.language }}</span>
                            </div>
                          <div class="position-relative">
                            <div class="backdrop"></div>
                            <div class="stars">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <div class="card-body bg-gold-light p-4 h-100">
                        <h5 class="price old"> {{packages.gold.oldPrice}} <span class="currency">{{packages.gold.currency}}/{{ 'Game.Year' | translate:locale.language }}</span></h5>
                        <h3 class="price"> {{packages.gold.price}} <span class="currency">{{packages.gold.currency}}/{{ 'Game.Year' | translate:locale.language }}</span></h3>
                        <ul class="list-unstyled price-list mt-4">
                            <li>
                                <span class="text-danger"><i class="bi bi-exclamation-triangle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureOnlyReg' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureAllGames' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureEvaluation' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureMonitoring' | translate:locale.language }}</span>
                            </li>
                                <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureKB' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureMeasure' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureSmartDevices' | translate:locale.language }}</span>
                            </li>
                        </ul>
                        </div>
                        <div class="p-4 bg-gold-light">
                            <a class="btn btn-warning btn-lg w-100" href="javascript:void(0);" (click)="onSelect('subscription/subscription/NO')">{{ 'Subscription.subscription' | translate:locale.language }}</a>
                        </div>
                    </div>
            </div>

                <div class="col-xl-4 col-md-12 mb-3">
                <div class="card d-flex justify-content-between h-100">
                        <div class="card-header d-flex justify-content-between bg-platinum p-0 position-relative">
                            <div class="p-4 text-uppercase">
                                <h1 class="fw-bold border-bottom border-dark border-2">{{ 'Subscription.PackagePlatinum' | translate:locale.language }}</h1>
                                <span>{{ 'Subscription.AtProvider' | translate:locale.language }}</span>
                            </div>
                          <div class="position-relative">
                            <div class="backdrop"></div>
                            <div class="stars">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-4 h-100">
                                   
                            <h3 class="price mb-5">{{ 'Subscription.CustomFee' | translate:locale.language }}</h3>
                            <ul class="list-unstyled price-list mt-4">
                            <li>
                                <span class="text-danger"><i class="bi bi-exclamation-triangle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureOnlyReg' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureAllGamesAndTests' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureEvaluation' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureMonitoringAndSurveillance' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureCompilation' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureMeasure' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureCommunication' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureKB' | translate:locale.language }}</span>
                            </li>
                            <li>
                                <span class="text-primary"><i class="bi bi-check-circle-fill"></i></span>
                                <span class="ms-2">{{ 'Subscription.FeatureSmartDevices' | translate:locale.language }}</span>
                            </li>

                        </ul>
                        </div>
                        <div class="p-4">
                            <a class="btn btn-warning btn-lg w-100" href="javascript:void(0);" (click)="onSelect('hc-provider-select')">{{ 'Subscription.ChooseProvider' | translate:locale.language }}</a>
                        </div>
                    </div>
                        
                               
                               
                </div>
                </div>
    </div>


</div>

